import React from "react";
import Helmet from "react-helmet";
// import { Link } from '@reach/router';

import Navigation from "../../components/WaveNavigation/";
import Beach from "../../components/Cards/beach";
import PageHeader from "../../components/PageHeader";

import seaviewimage from "../../assets/img/beaches/seaview.jpg";
import watertaxiimage from "../../assets/img/instagram/watertaxi@oceanbeach_fi.jpg";
import saltaireimage from "../communities/images/saltaire3@abonventre.jpg";
import fairharborimage from "../communities/images/fair-harbor@abonventre.jpg";
import oceanbeachimage from "../../assets/img/explore/ocean-beach.jpg";
import kismetimage from "../../assets/img/beaches/kismet.jpg";
import atlantiqueimage from "../../assets/img/explore/atlantique-hero.jpg";
import oceanbayparkimage from "../../assets/img/explore/ocean-bay-park-hero.jpg";

export default () => (
  <div>
    <Helmet
      title="Fire Island Ferries | Schedules"
      meta={[
        {
          name: "description",
          content:
            "Even though it’s only a short distance from Manhattan, Fire Island is a world away from the hustle and bustle of city life. Boasting 32 miles of pristine beaches, Fire Island offers visitors an escape from mainland pressures with beautiful Atlantic Ocean beaches, calming views of the Great South Bay, and access to peaceful wilderness.",
        },
        {
          name: "keywords",
          content: "Fire Island, New York, Long Island, Ferries, Water Taxi",
        },
      ]}
    />
    <Navigation />
    <div className="container p-0">
      <PageHeader>
        <h2>Schedules</h2>
        <h1>Fire Island</h1>
      </PageHeader>
    </div>
    <div className="container page">
      <div className="row justify-content-center">
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={kismetimage}
            link="/schedules/kismet"
            beach="Kismet"
            description="A family freindly community with beaches, shops, and restaurants."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={saltaireimage}
            link="/schedules/saltaire"
            beach="Saltaire"
            description="A primarily residential community with great views."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={fairharborimage}
            link="/schedules/fair-harbor"
            beach="Fair Harbor"
            description="Community with quaint walkways and fine dining."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={watertaxiimage}
            link="/schedules/dunewood"
            beach="Dunewood"
            description="A small community in a charming hamlet of Fire Island"
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={atlantiqueimage}
            link="/schedules/atlantique"
            beach="Atlantique"
            description="Limited access provides serenity unlike anywhere else."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={oceanbeachimage}
            link="/schedules/ocean-beach"
            beach="Ocean Beach"
            description="Something for everyone, beachs, restaurants, hotels, and shops."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={seaviewimage}
            link="/schedules/seaview"
            beach="Seaview"
            description="A family friendly community offering wholesome fun for everyone."
          />
        </div>
        <div className="col-xl-4 col-lg-6">
          <Beach
            image={oceanbayparkimage}
            link="/schedules/ocean-bay-park"
            beach="Ocean Bay Park"
            description="A lively community with restaurants and hotels."
          />
        </div>
      </div>

      <br />
      <br />
    </div>
  </div>
);
